import { z } from 'zod';

import { requiredArray } from '@/shared/utils/validation';

// A strict object would strip the id and a pipeline's trigger, which the update needs.
export const groupResourceSchema = z
  .object({
    groupId: z.string().nullable().optional(),
    objectVersion: z.number().nullable().optional(),
  })
  .passthrough();

export const addExistingResourcesInputSchema = z.object({
  resources: requiredArray(groupResourceSchema),
});
